import * as React from "react";
import { Colors } from "../design-tokens/colors";
import { Fonts } from "../design-tokens/fonts";
import { grid } from "../design-tokens/grid";

interface BadgeProps {
  color?: string;
}

const Badge: React.FC<BadgeProps> = ({ color = Colors.Purple, children }) => {
  return (
    <div
      css={{
        display: "inline-block",
        minWidth: grid(3),
        height: grid(1.5),
        fontSize: 10,
        fontWeight: Fonts.Weight.Bold,
        color: Colors.White,
        backgroundColor: color,
        paddingLeft: grid(0.5),
        paddingRight: grid(0.5),
        borderRadius: "3px",
      }}
    >
      {children}
    </div>
  );
};

export default Badge;
